module.exports = __webpack_public_path__ + "static/media/decrease-icon.25e1e98b.svg";